/**
 * Optimized FontAwesome icon configuration
 * Only imports the icons actually used in the package
 */

import { library, type IconDefinition } from '@fortawesome/fontawesome-svg-core';

// Regular icons
import {
  faArrowDownArrowUp,
  faArrowLeft,
  faArrowUpFromBracket,
  faArrowUpRightFromSquare,
  faArrowsRotate,
  faCalendar,
  faCheck,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faCircle,
  faCircleCheck,
  faCircleExclamation,
  faCircleInfo,
  faCircleXmark,
  faClock,
  faClockRotateLeft,
  faCopy,
  faEnvelope,
  faListCheck,
  faEye,
  faLink,
  faLinkSlash,
  faLock,
  faLockOpen,
  faMagnifyingGlass,
  faPlus,
  faPresentationScreen,
  faQrcode,
  faShareFromSquare,
  faTriangleExclamation,
  faSquare,
  faSquareCheck,
  faSquareMinus,
  faTrashCan,
  faUser,
  faUserGroup,
  faUsers,
  faXmark,
} from '@fortawesome/pro-regular-svg-icons';

// Solid icons
import {
  faEllipsis as faEllipsisSolid,
  faTag as faTagSolid,
  faBug,
  faBugSlash,
  faCaretDown as faCaretDownSolid,
  faCircleCheck as faCircleCheckSolid,
  faTrashCan as faTrashCanSolid,
  faXmark as faXmarkSolid,
} from '@fortawesome/pro-solid-svg-icons';

// Light icons
import { faClone as faCloneLight } from '@fortawesome/pro-light-svg-icons';

// Duotone light icons
import {
  faCircle1 as faCircle1Duotone,
  faCircle2 as faCircle2Duotone,
  faCircle3 as faCircle3Duotone,
  faCircleCheck as faCircleCheckDuotone,
} from '@fortawesome/duotone-light-svg-icons';

const regularIcons: IconDefinition[] = [
  faArrowDownArrowUp,
  faArrowLeft,
  faArrowUpFromBracket,
  faArrowUpRightFromSquare,
  faArrowsRotate,
  faCalendar,
  faCheck,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faCircle,
  faCircleCheck,
  faCircleExclamation,
  faCircleInfo,
  faClockRotateLeft,
  faCircleXmark,
  faClock,
  faCopy,
  faEnvelope,
  faListCheck,
  faEye,
  faLink,
  faLinkSlash,
  faLock,
  faLockOpen,
  faMagnifyingGlass,
  faPlus,
  faPresentationScreen,
  faQrcode,
  faShareFromSquare,
  faTriangleExclamation,
  faSquare,
  faSquareCheck,
  faSquareMinus,
  faTrashCan,
  faUser,
  faUserGroup,
  faUsers,
  faXmark,
];

const solidIcons: IconDefinition[] = [
  faEllipsisSolid,
  faTagSolid,
  faBug,
  faBugSlash,
  faCaretDownSolid,
  faCircleCheckSolid,
  faTrashCanSolid,
  faXmarkSolid,
];

const lightIcons: IconDefinition[] = [faCloneLight];

const duotoneIcons: IconDefinition[] = [faCircle1Duotone, faCircle2Duotone, faCircle3Duotone, faCircleCheckDuotone];

// Add all icon arrays to the library
library.add(...regularIcons);
library.add(...solidIcons);
library.add(...lightIcons);
library.add(...duotoneIcons);
